/**
 * Application Names
 * @type {{Community: string, EmployeeAccess: string}}
 */
const names = {
  // Community: "Community",
  EmployeeAccess: "EmployeeAccess"
};

/**
 * Application Titles
 * @type {{Community: string, EmployeeAccess: string}}
 */
const titles = {
  // Community: "Community",
  EmployeeAccess: "Employee Access"
};

/**
 * Application Icons
 * @type {{Community: string}}
 */
const icons = {
  // Community: "mdi-domain",
  EmployeeAccess: "mdi-account-circle-outline"
};

/**
 * Applications
 * @type [{icon: string, name: string, title: string}]
 */
const apps = [
  // {
  //   title: titles.Community,
  //   icon: icons.Community,
  //   name: names.Community
  // },
  {
    title: titles.EmployeeAccess,
    icon: icons.EmployeeAccess,
    name: names.EmployeeAccess
  }
];

export { names, titles, icons, apps };
